import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IPartnersExt } from 'legacy/lut/classes/models/IFormCodeLog'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import * as React from 'react'
import { useMemo } from 'react'

import { Table } from 'core-components/library/list'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export interface IProps {
  widgetParams?: IObjectAny
  partners?: IFormPartners[]
  partnerID: string
  filterPartner?: string
  selectedPartner?: string
  flexWidth?: string
  onClose: any
  pid?: string
  createdByEmailFilter: string
}

export const PartnerLogDialog = (props: IProps) => {
  const crudSource = useMemo(() => {
    const { pid, partnerID } = props
    const source = CrudStore.get(CrudStoreItem.PartnerLog)
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          operator: Operator.EQUAL,
          value: pid || partnerID,
        },
      ],
    }
    source.setFilter(filter)
    source.setSort({ field: 'Created', dir: 'desc' })
    return source
  }, [props.pid, props.partnerID])

  const getColumn = useMemo(() => {
    return [
      { field: 'Created', title: 'Created', priority: 1 },
      { field: 'WorkflowStatus', title: 'Work flow Status', priority: 2 },
      { field: 'ModifiedValues', title: 'Modified Values', priority: 3 },
      {
        field: 'ProfileTeamComment',
        title: 'Profile Team Comment',
        priority: 4,
      },
      { field: 'EntryId', title: 'EntryId', priority: 5 },
      { field: 'EntryIdSource', title: 'EntryIdSource', priority: 6 },
      //{ field: 'ActionFrom', title: 'Action From', priority: 7 }, // Not exist in 406
      { field: 'PartnerID', title: 'Partner ID', priority: 8 },
      { field: 'LocationID', title: 'Location ID', priority: 9 },
      { field: 'TaxID', title: 'Tax ID', priority: 10 },
      { field: 'CommunicationName', title: 'Comm. Name', priority: 11 },
      { field: 'CompanyLegalName', title: 'Legal Name', priority: 12 },
      { field: 'Country', title: 'Country', priority: 13 },
      {
        field: 'MainPhoneCountryCode',
        title: 'Phone country code',
        priority: 14,
      },
      { field: 'MainPhone', title: 'Phone', priority: 15 },
      { field: 'AddressLine1', title: 'Address Line 1', priority: 16 },
      { field: 'AddressLine2', title: 'Address Line 2', priority: 17 },
      { field: 'AddressLine3', title: 'Address Line 3', priority: 18 },
      { field: 'LegalAddr1', title: 'Legal Address 1', priority: 19 },
      { field: 'LegalAddr2', title: 'Legal Address 2', priority: 20 },
      { field: 'LegalAddr3', title: 'Legal Address 3', priority: 21 },
      { field: 'State', title: 'State', priority: 22 },
      { field: 'ZIPCode', title: 'ZIPCode', priority: 23 },
      { field: 'City', title: 'City', priority: 24 },
      { field: 'LegalCity', title: 'LegalCity', priority: 25 },
      { field: 'LegalCountry', title: 'LegalCountry', priority: 26 },
      { field: 'LegalPostalCode', title: 'LegalPostalCode', priority: 27 },
      { field: 'Email', title: 'Email', priority: 28 },
      { field: 'URL', title: 'URL', priority: 29 },
      //
      // Additional fields in 406:
      //
      //CreatedBy?: string
      //App?: string
      //TriggerAction?: string
      //CreatedSource?: string
      //CreatedBySource?: string
      //ModifiedSource?: string
      //ModifiedBySource?: string
      //TopPartnerID?: string
      //Hierarchy?: string
      //AlertAt?: string
      //Market?: string
      //CompanyLegalNameNonLatin?: string
      //Attachment?: string
      //ProfileApproverComment?: string
      //LastRequest?: string
      //Processed_Date?: string
      //StoreNumber?: string
      //EcommerceURL?: string
      //SocialMediaURL?: string
      //LegalState?: string
      //RequestStarted?: string
      //NotificationSendLog?: string
      //Source?: string
      //Status?: string
    ]
  }, [])

  return (
    <Table<IPartnersExt>
      key={props.pid || props.partnerID}
      header
      pagination
      source={crudSource}
      columns={getColumn}
      hasRefresh
    />
  )
}
